import { render } from "./featuredVideos.vue?vue&type=template&id=285f6801"
import script from "./featuredVideos.vue?vue&type=script&lang=js"
export * from "./featuredVideos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__